import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { SwitchButton } from '@lean-body/src/view/atoms/switch_button';
export const LabelSwitchButton = (props) => {
    return (React.createElement("div", { className: css(props.classObject) },
        React.createElement("div", { className: css(styles.switchLabel) }, props.label),
        React.createElement(SwitchButton, { classObject: styles.switchButton, onClick: props.onClick, isOn: props.isOn })));
};
const styles = StyleSheet.create({
    switchLabel: {
        fontSize: 12,
        fontWeight: 'bold',
        lineHeight: '19.2px',
        marginRight: 20,
    },
    switchButton: {
        marginTop: 2,
    },
});
